document.querySelectorAll('.newsletter-button').forEach((element) => {
	element.addEventListener('click', () => {
		element.classList.add('hidden');
		document.querySelector('.newsletter-modal').classList.remove('hidden');
		document.querySelector('body').classList.add('newsletter-modal-open');
	});
});

document.addEventListener('click', event => {
	if (event.target.matches('.newsletter-button')) {
		return;
	}
	const newsletterButton = document.querySelector('.newsletter-button');
	if (!newsletterButton) {
		return;
	}
	// Close the modal window if the user either clicks the X button or clicks outside the modal window.
	if (event.target.matches('.newsletter-close') || !event.target.closest('.newsletter-modal')) {
		newsletterButton.classList.remove('hidden');
		closeModal();
	}
}, false);

function closeModal() {
	document.querySelector('.newsletter-modal').classList.add('hidden');
	document.querySelector('body').classList.remove('newsletter-modal-open');
}
